import React from 'react'
import { Link } from 'react-router'
import styles from './ReportCard.scss'
import smartDate from '@qrohlf/smart-date'
import {Badge} from 'common/Badge'
import {clampString} from 'lib/utils'
import cx from 'classnames'
import {getReportCover} from 'lib/getReportCover'

export const ReportCard = ({report, currentUser = {}, overlay}) => {
  const imgSrc = getReportCover(report)
  const backgroundImg = {
    backgroundImage: `url(${imgSrc})`,
    backgroundPosition: 'center center',
    backgroundSize: 'cover'
  }
  const A = ({children, className}) => <Link className={cx(styles.reportLink, className)} to={`/ride_reports/${report.slug}`}>{children}</Link>
  return (
    <div className={styles.ReportCard}>
      <A className={styles.mediaContainer}>
        <div className={styles.media} style={backgroundImg} />
        {overlay && <img src={overlay} className={styles.weeklyBadge} />}
      </A>
      <div className={styles.cardContent}>
        <div className={styles.meta}>
          {report.publishStatus === 'draft' && [<Badge key='draftBadge'>draft</Badge>, ' ∙ ']}
          <Link to={`/ride_reports/user/${report.user.id}`}>{report.user.name}</Link>
          {' ∙ '} {smartDate(report.createdAt)}
          {currentUser.id === report.user.id && [' ∙ ', <Link key='editButton' to={`/ride_reports/${report.slug}/edit`}>edit</Link>]}

        </div>
        <A>
          <h2 className={styles.title}>{report.title}</h2>
        </A>
        <h3 className={styles.subtitle}>{report.subtitle && clampString(report.subtitle, 130)}</h3>
      </div>
    </div>
  )
}
